import { TextInput } from "@carbon/react";
import { useState, useEffect } from "react";
import { useMutation, gql } from "@apollo/client";
import { useNavigate } from "react-router-dom";

const CREATE_TOPIC_MUTATION = gql`
    mutation CreateTopic($name: String!) {
        createTopic(name: $name) {
            id
            name
        }
    }
`;

export function CreateTopic() {
    const [createTopic] = useMutation(CREATE_TOPIC_MUTATION);
    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [continueEnabled, setContinueEnabled] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    function validateForm() {
        if (name.trim() === '') {
            setErrorMessage('Themenname ist erforderlich.');
            setContinueEnabled(false);
            return false;
        }
        setErrorMessage('');
        setContinueEnabled(true);
        return true;
    }

    useEffect(() => {
        validateForm();
    }, [name]);

    function handleSubmit(event) {
        event.preventDefault();
        if (!validateForm()) return;

        createTopic({
            variables: {
                name: name.trim()
            }
        }).then(() => {
            navigate("/admin/topics");
        }).catch((err) => {
            setErrorMessage("Fehler beim Erstellen des Themas.");
        });
    }

    return (
        <div className="py-4">
            <div className="max-w-2xl">
                <h1 className="text-2xl font-bold text-gray-900">
                    Thema erstellen
                </h1>
                <form onSubmit={handleSubmit} className="mt-8 space-y-6">
                    <TextInput
                        id="name"
                        labelText="Themenname"
                        placeholder="Themenname eingeben (z.B. Mathematik)"
                        className="w-full"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />

                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-4">
                        <p className="text-sm text-red-600 h-5">
                            {errorMessage}
                        </p>
                        <button
                            type="submit"
                            className={`mainBtn w-full sm:w-auto text-white px-6 py-2 transition-opacity duration-200 ${
                                continueEnabled ? 'hover:bg-blue-700' : 'opacity-50 cursor-not-allowed'
                            }`}
                            disabled={!continueEnabled}
                        >
                            Thema erstellen
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
